/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S5_P1Inputs */

const en_guide_what_is_json_s5_p1 = /** @type {(inputs: Guide_What_Is_Json_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When working with JSON data, you'll frequently need to format, validate, and transform it. Raw JSON from APIs often comes minified (without whitespace), making it difficult to read. A <a href="/json-formatter">JSON formatter</a> adds proper indentation so you can quickly understand the data structure.`)
};

const ko_guide_what_is_json_s5_p1 = /** @type {(inputs: Guide_What_Is_Json_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 데이터를 다룰 때 포맷팅, 유효성 검사, 변환이 자주 필요합니다. API에서 받은 원시 JSON은 종종 압축되어(공백 없이) 읽기 어렵습니다. <a href="/json-formatter">JSON 포맷터</a>로 적절한 들여쓰기를 추가하면 데이터 구조를 빠르게 파악할 수 있습니다.`)
};

const ja_guide_what_is_json_s5_p1 = /** @type {(inputs: Guide_What_Is_Json_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONデータを扱う際、フォーマット、検証、変換が頻繁に必要になります。APIから取得した生のJSONは通常、圧縮された状態（空白なし）で届くため、読みづらくなります。<a href="/json-formatter">JSONフォーマッター</a>は適切なインデントを追加して、データ構造をすぐに理解できるようにします。`)
};

/**
* | output |
* | --- |
* | "When working with JSON data, you'll frequently need to format, validate, and transform it. Raw JSON from APIs often comes minified (without whitespace), maki..." |
*
* @param {Guide_What_Is_Json_S5_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s5_p1 = /** @type {((inputs?: Guide_What_Is_Json_S5_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S5_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s5_p1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s5_p1(inputs)
	return ja_guide_what_is_json_s5_p1(inputs)
});